export default "__VITE_ASSET__DiNFqZwz__"